<template>
    <div class="music--form-container">
        <data-container>
            <template #content>
                <MusicForm
                    @submit="submit"
                    @cancel="$router.push({ name: 'SongsList' })" />
            </template>
        </data-container>
    </div>
</template>

<script>
import DataContainer from '@/components/DataContainer'
import MusicForm from '@/components/MusicForm'
import song from '@/store/song/app.js'
import { mapFields } from 'vuex-map-fields'

export default {
	methods: {
		submit () {
			const form = new FormData()
			Object.keys(this.form).forEach(key => {
				form.set(key, this.form[key])
			})

			this.$store.dispatch('song/create', form)
	    }
	},
	components: {
		DataContainer,
		MusicForm
	},
	computed: {
		...mapFields('song', ['form'])
	},
	beforeCreate () {
		if (!this.$store.hasModule('song')) {
			this.$store.registerModule('song', song)
		}
	}
}
</script>

<style lang="scss" scoped>
.data-container {
    width: 480px;
}

.music--form-container {
    padding: 1.5em;
}
</style>
